<template>
    <div id="search-form">
        <form @submit.prevent="submit">
            <span @click="submit"><i class="fas fa-search"></i></span>
            <input type="text" placeholder="Search..." v-model="search">
        </form>
    </div>
</template>
<script>
    export default {
        props: {
            keyword: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                search: this.keyword
            }
        },
        methods: {
            submit() {
                window.axios.post('/search-submit', {
                        keyword: this.search
                    })
                    .then(this.success)
                    .catch(this.failure);
            },
            success(response) {
                window.location.href = response.data.redirect;
            },
            failure(error) {
                throw new Error(error);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/src/components/Search/Form.vue